import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Elevator = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 16 16"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <defs>
          <clipPath id="elevator__a">
            <rect
              x="0"
              y="0"
              width="16"
              height="16"
              rx="0"
            />
          </clipPath>
        </defs>
        <g clipPath="url(#elevator__a)">
          <path
            d="M13,2L3,2C2.73478508,2,2.48042989,2.10535502,2.29289508,2.29289508C2.10535502,2.48042989,2,2.73478508,2,3L2,13C2,13.2652,2.10535502,13.51955,2.29289508,13.7071C2.48042989,13.89465,2.73478508,14,3,14L13,14C13.2652,14,13.51955,13.89465,13.7071,13.7071C13.89465,13.51955,14,13.2652,14,13L14,3C14,2.73478508,13.89465,2.48042989,13.7071,2.29289508C13.51955,2.10535502,13.2652,2,13,2ZM7,3.5L9,3.5C9.132599800000001,3.5,9.2598,3.55268,9.35355,3.646445C9.4473,3.7402151,9.5,3.8673899,9.5,4C9.5,4.1326098,9.4473,4.2597852,9.35355,4.353555200000001C9.2598,4.4473199999999995,9.132599800000001,4.5,9,4.5L7,4.5C6.8674002,4.5,6.7402,4.4473199999999995,6.64645,4.353555200000001C6.5527,4.2597852,6.5,4.1326098,6.5,4C6.5,3.8673899,6.5527,3.7402151,6.64645,3.646445C6.7402,3.55268,6.8674002,3.5,7,3.5ZM7.5,13L4,13L4,6L7.5,6L7.5,13ZM12,13L8.5,13L8.5,6L12,6L12,13Z"
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
